import { ablyErrorDetails } from "./errorTypes/ably";
import { agentActionsErrorDetails } from "./errorTypes/agent-actions";
import { airtableErrorDetails } from "./errorTypes/airtable";
import { anthropicErrorDetails } from "./errorTypes/anthropic";
import { audioProcessingErrorDetails } from "./errorTypes/audioProcessing";
import { baseErrorDetails } from "./errorTypes/base";
import { classifyErrorDetails } from "./errorTypes/classify";
import { cloudflareAiErrorDetails } from "./errorTypes/cloudflare-ai";
import { companyCamErrorDetails } from "./errorTypes/companyCam";
import { contextErrorDetails } from "./errorTypes/context";
import { dataSyncErrorDetails } from "./errorTypes/dataSync";
import { dbErrorDetails } from "./errorTypes/db";
import { diPatternErrorDetails } from "./errorTypes/di-pattern";
import { dropboxSignPackageErrorDetails } from "./errorTypes/dropboxSign";
import { environmentErrorDetails } from "./errorTypes/environment";
import { eqhoErrorDetails } from "./errorTypes/eqho";
import { financeErrorDetails } from "./errorTypes/finance";
import { formattingErrorDetails } from "./errorTypes/formatting";
import { githubErrorDetails } from "./errorTypes/github";
import { gmailErrorDetails } from "./errorTypes/gmail";
import { goodleapErrorDetails } from "./errorTypes/goodleap";
import { googleAiErrorDetails } from "./errorTypes/googleAi";
import { googleCalendarErrorDetails } from "./errorTypes/googleCalendar";
import { googleSheetsErrorDetails } from "./errorTypes/googleSheets";
import { googleTranslateErrorDetails } from "./errorTypes/googleTranslate";
import { grooveErrorDetails } from "./errorTypes/groove";
import { gutCheckErrorDetails } from "./errorTypes/gutCheck";
import { hoverErrorDetails } from "./errorTypes/hover";
import { hubspotErrorDetails } from "./errorTypes/hubspot";
import { inspectifyErrorDetails } from "./errorTypes/inspectify";
import { knockErrorDetails } from "./errorTypes/knock";
import { langchainErrorDetails } from "./errorTypes/langchain";
import { lensingErrorDetails } from "./errorTypes/lensing";
import { linearErrorDetails } from "./errorTypes/linear";
import { localizationErrorDetails } from "./errorTypes/localization";
import { loggingErrorDetails } from "./errorTypes/logging";
import { mapboxErrorDetails } from "./errorTypes/mapbox";
import { materialsErrorDetails } from "./errorTypes/materials";
import { mcpErrorDetails } from "./errorTypes/mcp";
import { measurementReportErrorDetails } from "./errorTypes/measurementReport";
import { monitorsErrorDetails } from "./errorTypes/monitors";
import { nearmapErrorDetails } from "./errorTypes/nearmap";
import { notificationsErrorDetails } from "./errorTypes/notifications";
import { openaiErrorDetails } from "./errorTypes/openai";
import { openlyErrorDetails } from "./errorTypes/openly";
import { openPhoneErrorDetails } from "./errorTypes/openPhone";
import { pandadocErrorDetails } from "./errorTypes/pandadoc";
import { payKeeperErrorDetails } from "./errorTypes/payKeeper";
import { permissionsErrorDetails } from "./errorTypes/permissions";
import { phasesErrorDetails } from "./errorTypes/phases";
import { planetscaleErrorDetails } from "./errorTypes/planetscale";
import { propertyModelErrorDetails } from "./errorTypes/propertyModel";
import { puppeteerErrorDetails } from "./errorTypes/puppeteer";
import { quickbooksErrorDetails } from "./errorTypes/quickbooks";
import { quotingErrorDetails } from "./errorTypes/quoting";
import { redisErrorDetails } from "./errorTypes/redis";
import { s3ErrorDetails } from "./errorTypes/s3";
import { secretsManagerErrorDetails } from "./errorTypes/secretsManager";
import { securityErrorDetails } from "./errorTypes/security";
import { sentryErrorDetails } from "./errorTypes/sentry";
import { slackErrorDetails } from "./errorTypes/slack";
import { smartyErrorDetails } from "./errorTypes/smarty";
import { smsErrorDetails } from "./errorTypes/sms";
import { sqsErrorDetails } from "./errorTypes/sqs";
import { sunlightErrorDetails } from "./errorTypes/sunlight";
import { sunrunErrorDetails } from "./errorTypes/sunrun";
import { sunrunApiErrorDetails } from "./errorTypes/sunrunApi";
import { sunrunAutomationErrorDetails } from "./errorTypes/sunrunAutomation";
import { svixErrorDetails } from "./errorTypes/svix";
import { symbilityErrorDetails } from "./errorTypes/symbility";
import { threeDModelDataProcessingErrorDetails } from "./errorTypes/threeDModelDataProcessing";
import { tinybirdErrorDetails } from "./errorTypes/tinybird";
import { twilioErrorDetails } from "./errorTypes/twilio";
import { typesafeErrorDetails } from "./errorTypes/typesafe";
import { upstashErrorDetails } from "./errorTypes/upstash";
import { utilsErrorDetails } from "./errorTypes/utils";
import { val3dityErrorDetails } from "./errorTypes/val3dity";
import { workflowErrorDetails } from "./errorTypes/workflow";
import { xactanalysisErrorDetails } from "./errorTypes/xactanalysis";
import { RemiPackage } from "./errorTypes/remi-package";
import type { RemiErrorInput } from "./remiErrorInput";

export interface RemiErrorDetails {
  sentryDescription: string;
}

export function getRemiErrorDetails(input: RemiErrorInput): RemiErrorDetails {
  switch (input.remiPackage) {
    case RemiPackage.ABLY:
      return ablyErrorDetails[input.errorType];
    case RemiPackage.AIRTABLE:
      return airtableErrorDetails[input.errorType];
    case RemiPackage.ANTHROPIC:
      return anthropicErrorDetails[input.errorType];
    case RemiPackage.DATA_SYNC:
      return dataSyncErrorDetails[input.errorType];
    case RemiPackage.AUDIO_PROCESSING:
      return audioProcessingErrorDetails[input.errorType];
    case RemiPackage.VAL3DITY:
      return val3dityErrorDetails[input.errorType];
    case RemiPackage.MEASUREMENT_REPORT:
      return measurementReportErrorDetails[input.errorType];
    case RemiPackage.BASE:
      return baseErrorDetails[input.errorType];
    case RemiPackage.CLASSIFY:
      return classifyErrorDetails[input.errorType];
    case RemiPackage.CLOUDFLARE_AI:
      return cloudflareAiErrorDetails[input.errorType];
    case RemiPackage.COMPANY_CAM:
      return companyCamErrorDetails[input.errorType];
    case RemiPackage.CONTEXT:
      return contextErrorDetails[input.errorType];
    case RemiPackage.DB:
      return dbErrorDetails[input.errorType];
    case RemiPackage.DI_PATTERN:
      return diPatternErrorDetails[input.errorType];
    case RemiPackage.ENVIRONMENT:
      return environmentErrorDetails[input.errorType];
    case RemiPackage.EQHO:
      return eqhoErrorDetails[input.errorType];
    case RemiPackage.FINANCE:
      return financeErrorDetails[input.errorType];
    case RemiPackage.FORMATTING:
      return formattingErrorDetails[input.errorType];
    case RemiPackage.GMAIL:
      return gmailErrorDetails[input.errorType];
    case RemiPackage.GROOVE:
      return grooveErrorDetails[input.errorType];
    case RemiPackage.GOODLEAP:
      return goodleapErrorDetails[input.errorType];
    case RemiPackage.GOOGLE_AI:
      return googleAiErrorDetails[input.errorType];
    case RemiPackage.GOOGLE_CALENDAR:
      return googleCalendarErrorDetails[input.errorType];
    case RemiPackage.GOOGLE_SHEETS:
      return googleSheetsErrorDetails[input.errorType];
    case RemiPackage.GOOGLE_TRANSLATE:
      return googleTranslateErrorDetails[input.errorType];
    case RemiPackage.GUT_CHECK:
      return gutCheckErrorDetails[input.errorType];
    case RemiPackage.HUBSPOT:
      return hubspotErrorDetails[input.errorType];
    case RemiPackage.INSPECTIFY:
      return inspectifyErrorDetails[input.errorType];
    case RemiPackage.KNOCK:
      return knockErrorDetails[input.errorType];
    case RemiPackage.LANGCHAIN:
      return langchainErrorDetails[input.errorType];
    case RemiPackage.LENSING:
      return lensingErrorDetails[input.errorType];
    case RemiPackage.LINEAR:
      return linearErrorDetails[input.errorType];
    case RemiPackage.LOCALIZATION:
      return localizationErrorDetails[input.errorType];
    case RemiPackage.LOGGING:
      return loggingErrorDetails[input.errorType];
    case RemiPackage.MAPBOX:
      return mapboxErrorDetails[input.errorType];
    case RemiPackage.MATERIALS:
      return materialsErrorDetails[input.errorType];
    case RemiPackage.MCP:
      return mcpErrorDetails[input.errorType];
    case RemiPackage.NOTIFICATIONS:
      return notificationsErrorDetails[input.errorType];
    case RemiPackage.OPENAI:
      return openaiErrorDetails[input.errorType];
    case RemiPackage.AGENT_ACTIONS:
      return agentActionsErrorDetails[input.errorType];
    case RemiPackage.OPEN_PHONE:
      return openPhoneErrorDetails[input.errorType];
    case RemiPackage.PANDADOC:
      return pandadocErrorDetails[input.errorType];
    case RemiPackage.PAY_KEEPER:
      return payKeeperErrorDetails[input.errorType];
    case RemiPackage.PERMISSIONS:
      return permissionsErrorDetails[input.errorType];
    case RemiPackage.PHASES:
      return phasesErrorDetails[input.errorType];
    case RemiPackage.PLANETSCALE:
      return planetscaleErrorDetails[input.errorType];
    case RemiPackage.PROPERTY_MODEL:
      return propertyModelErrorDetails[input.errorType];
    case RemiPackage.PUPPETEER:
      return puppeteerErrorDetails[input.errorType];
    case RemiPackage.QUICKBOOKS:
      return quickbooksErrorDetails[input.errorType];
    case RemiPackage.QUOTING:
      return quotingErrorDetails[input.errorType];
    case RemiPackage.REDIS:
      return redisErrorDetails[input.errorType];
    case RemiPackage.S3:
      return s3ErrorDetails[input.errorType];
    case RemiPackage.SECRETS_MANAGER:
      return secretsManagerErrorDetails[input.errorType];
    case RemiPackage.SECURITY:
      return securityErrorDetails[input.errorType];
    case RemiPackage.SENTRY:
      return sentryErrorDetails[input.errorType];
    case RemiPackage.SLACK:
      return slackErrorDetails[input.errorType];
    case RemiPackage.SMARTY:
      return smartyErrorDetails[input.errorType];
    case RemiPackage.SMS:
      return smsErrorDetails[input.errorType];
    case RemiPackage.SQS:
      return sqsErrorDetails[input.errorType];
    case RemiPackage.SUNLIGHT:
      return sunlightErrorDetails[input.errorType];
    case RemiPackage.SUNRUN:
      return sunrunErrorDetails[input.errorType];
    case RemiPackage.SUNRUN_API:
      return sunrunApiErrorDetails[input.errorType];
    case RemiPackage.SUNRUN_AUTOMATION:
      return sunrunAutomationErrorDetails[input.errorType];
    case RemiPackage.SVIX:
      return svixErrorDetails[input.errorType];
    case RemiPackage.TWILIO:
      return twilioErrorDetails[input.errorType];
    case RemiPackage.TYPESAFE:
      return typesafeErrorDetails[input.errorType];
    case RemiPackage.UPSTASH:
      return upstashErrorDetails[input.errorType];
    case RemiPackage.UTILS:
      return utilsErrorDetails[input.errorType];
    case RemiPackage.WORKFLOW:
      return workflowErrorDetails[input.errorType];
    case RemiPackage.XACTANALYSIS:
      return xactanalysisErrorDetails[input.errorType];
    case RemiPackage.GITHUB:
      return githubErrorDetails[input.errorType];
    case RemiPackage.MONITORS:
      return monitorsErrorDetails[input.errorType];
    case RemiPackage.NEARMAP:
      return nearmapErrorDetails[input.errorType];
    case RemiPackage.HOVER:
      return hoverErrorDetails[input.errorType];
    case RemiPackage.SYMBILITY:
      return symbilityErrorDetails[input.errorType];
    case RemiPackage.OPENLY:
      return openlyErrorDetails[input.errorType];
    case RemiPackage.TINYBIRD:
      return tinybirdErrorDetails[input.errorType];
    case RemiPackage.DROPBOX_SIGN:
      return dropboxSignPackageErrorDetails[input.errorType];
    case RemiPackage.THREE_D_MODEL_DATA_PROCESSING:
      return threeDModelDataProcessingErrorDetails[input.errorType];
    // Do not add a default case to this switch statement so that lint fails if the list is not exhaustive
  }
}
